import { constantRouterMap } from '@/router/index';
import businessRoutes from '@/router/business';
import adminRouter from '@/router/adminRoutes';
const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },
  actions: {
    GenerateRoutes({ commit },data) {
      return new Promise(resolve => {
        const { userType } = data;
        let accessedRoutes = []
              // 根据角色选择路由表
              switch(userType) {
                case 'MERCHANT':
                  accessedRoutes = [
                    ...businessRoutes
                   
                  ]
                  break
                case 'PLATFORM_ADMIN':
                  accessedRoutes = [
                    ...adminRouter
                  ]
                  break
                default:
                  throw new Error('未知用户角色')
              }
        commit('SET_ROUTERS',accessedRoutes);
        resolve();
      })
    }
  }
};

export default permission;




// WEBPACK FOOTER //
// ./src/store/modules/permission.js